import { Directive, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { BaseControl } from './base-control';
import { AppFormControlField } from '../../../models/form-controls.model';
import { getErrorMessage } from '../form-error.util';

@Directive()
export abstract class BaseFormControl<T> extends BaseControl<T> {
    @Input() field!: AppFormControlField;

    
    @Input() override disabled:boolean = false

    constructor(
        @Optional() @Self() public ngControl: NgControl
    ) {
        super();
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    get errorMessage(): string {
        if (!this.ngControl) return '';
        const control = this.ngControl.control;
        if (!control || typeof control !== 'object') return '';
        if (typeof (control as any).touched !== 'boolean') return '';
        if (!(control as any).touched || !control.errors) return '';
        return getErrorMessage(control.errors, this.field.label);
    }
}